export enum BORDER_RADIUS {
  SMALL = 4,
  MEDIUM = 8,
  LARGE = 10,
}

export enum BOX_SHADOW {
  BUTTON = '4px 8px 16px 0px #2B344538',
}
